import React from 'react';
//import HomePageContainer from './components/main/HomePageContainer';
import {BrowserRouter, Route} from "react-router-dom";
import CompanyPageContainer from "./components/company/CompanyPageContainer";

class App extends React.Component {
    render() {
        return (
        <BrowserRouter basename={process.env.REACT_APP_ROUTER_BASE || ''}>
            <React.Fragment>
                {/*}
                <Route exact path='/' component={HomePageContainer}/>
                */}
                <Route exact path='/' component={CompanyPageContainer}/>
            </React.Fragment>
        </BrowserRouter>
        );
    };


};

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx